/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 住所マスタ情報
 */
export interface Szza019aRequestAddressMasterInfo { 
    /**
     * 住所コード：数字
     */
    addressCode: string;
    /**
     * 適用開始日付(変更前)：日付(yyyyMMdd)<br>　「マスタ登録区分」＝\'2\'（変更）、\'3\'（削除）の場合に設定
     */
    applyStartDateBefore?: string;
    /**
     * 適用開始日付(変更後)：日付(yyyyMMdd)<br>　「マスタ登録区分」＝\'1\'（追加）、\'2\'（変更）の場合に設定
     */
    applyStartDate?: string;
    /**
     * 適用終了日付：日付(yyyyMMdd)<br>　「マスタ登録区分」＝\'1\'（追加）、\'2\'（変更）の場合に設定
     */
    applyEndDate?: string;
    /**
     * 郵便番号：数字<br>　「マスタ登録区分」＝\'1\'（追加）、\'2\'（変更）の場合に設定\"
     */
    zipCode?: string;
    /**
     * 都道府県名称：全角（漢字/かな/カナ/数字/英字/スペース/記号)<br>　「マスタ登録区分」＝\'1\'（追加）、\'2\'（変更）の場合に設定\"
     */
    prefecturesName?: string;
    /**
     * 市区郡町村名称：全角（漢字/かな/カナ/数字/英字/スペース/記号)<br>　「マスタ登録区分」＝\'1\'（追加）、\'2\'（変更）の場合に設定\"
     */
    cityName?: string;
    /**
     * 町域名称：全角（漢字/かな/カナ/数字/英字/スペース/記号)<br>　「マスタ登録区分」＝\'1\'（追加）、\'2\'（変更）の場合に設定\"
     */
    townAreaName?: string;
    /**
     * 大字丁目名称：全角（漢字/かな/カナ/数字/英字/スペース/記号)<br>　「マスタ登録区分」＝\'1\'（追加）、\'2\'（変更）の場合に設定\"
     */
    ooazaName?: string;
    /**
     * 都道府県カナ名：全角（カナ/数字/英字/スペース/記号)<br>　「マスタ登録区分」＝\'1\'（追加）、\'2\'（変更）の場合に設定\"
     */
    prefecturesKanaName?: string;
    /**
     * 市区郡町村カナ名：全角（カナ/数字/英字/スペース/記号)<br>　「マスタ登録区分」＝\'1\'（追加）、\'2\'（変更）の場合に設定\"
     */
    cityKanaName?: string;
    /**
     * 町域カナ名：全角（カナ/数字/英字/スペース/記号)<br>　「マスタ登録区分」＝\'1\'（追加）、\'2\'（変更）の場合に設定\"
     */
    townAreaKanaName?: string;
    /**
     * 大字丁目カナ名：全角（カナ/数字/英字/スペース/記号)<br>　「マスタ登録区分」＝\'1\'（追加）、\'2\'（変更）の場合に設定\"
     */
    ooazaKanaName?: string;
    /**
     * 更新通番号：数字<br>　「マスタ登録区分」＝\'2\'（変更）、\'3\'（削除）の場合に設定
     */
    updateSrno?: string;
}

